<template>
    <div>
        <PageHeader :page_title="page_title"/>
        <pSpinner v-if="loading"></pSpinner>
        <template v-if="!loading">
            <v-tabs  v-model="active_tab1" color="grey  lighten-3" dark  slider-color = "primary" >
                    <v-tab ripple class = "black--text ml-4" v-for="tab of tabs"  :key="tab.id"  @click="redirectTo(tab.id,tab.link)" >
                         {{tab.name}}
                    </v-tab>
            </v-tabs>
            <div :class="{'ml-1': $vuetify.breakpoint.mdAndUp,'mr-1': $vuetify.breakpoint.mdAndUp,'ml-0': $vuetify.breakpoint.smAndDown,'mr-0': $vuetify.breakpoint.smAndDown,}" >
            <v-alert :value="alert" class="cyb-alert-info mt-3 mb-0 pb-0"  >{{alert_message}}<v-icon  @click = "alert = false" style="padding-bottom: 8px;float: right;font-size: 19.5px;font-weight: bold;line-height: 1;"  class="close_hover" >close</v-icon></v-alert> 
            </div>
            <v-container fluid>
                
                <v-card>
                    <v-form ref="form">
                        <v-container fluid>
                            <v-layout row wrap>
                                <template>
                                    <v-flex xs12 sm4>
                                        <v-text-field  :value="fdl.account_id" label="Account Number" readonly ></v-text-field>
                                    </v-flex>
                                    
                                    <!--<v-flex xs12 sm4>-->
                                    <!--    <v-text-field :value="fdl_details.status" label="Status" readonly></v-text-field>-->
                                    <!--</v-flex>-->
                                    
                                    <!--<v-flex xs12 sm4 v-if="fdl_details.status=='Closed'">-->
                                    <!--    <v-text-field :value="fdl_details.closed_on" label="Closed On" readonly></v-text-field>-->
                                    <!--</v-flex>-->
                                    
                                    <v-flex xs12 sm4>
                                        <v-text-field :value="fdl_details.activated_on" label="Loan Date" readonly ></v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12 sm4>
                                        <v-text-field :value="fdl_details.mode_operation"  label="Account Type" readonly ></v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12 sm4>
                                        <v-text-field :value="fdl.office_name" label="Branch" readonly></v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12 sm4>
                                        <v-text-field :value="fdl.amount" label="Loan Amount"  readonly></v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12 sm4>
                                        <v-text-field :value="fdl.interest" label="Interest Rate" readonly></v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12 sm4>
                                    <v-text-field :value="fdl.tenure"  label="Tenure In Months" readonly ></v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12 sm4>
                                      <v-text-field :value="fdl.scheme" label="Scheme" readonly ></v-text-field>
                                    </v-flex>
                                    
                                    <!--<v-flex xs12 sm4>-->
                                    <!--  <v-text-field :value="fdl_details.deposit_id" label="FD Number" readonly ></v-text-field>-->
                                    <!--</v-flex>-->
                                    
                                    <!--<v-flex xs12 sm4>-->
                                    <!--  <v-text-field :value="fdl_details.completed_duration" label="Completed Duration" readonly ></v-text-field>  -->
                                    <!--</v-flex>-->
                                    
                                    <v-flex xs12 sm4>
                                      <v-text-field :value="fdl_details.interest_amount_pending" label="Interest Pending" readonly ></v-text-field>  
                                    </v-flex>
                                    
                                    <!--<v-flex xs12 sm4>-->
                                    <!--  <v-text-field :value="fdl_details.principal_amount_pending" label="Principal Pending" readonly ></v-text-field>  -->
                                    <!--</v-flex>-->
                                    
                                    <v-flex xs12 sm4>
                                      <v-text-field :value="fdl_details.outstanding_amount" label="Outstanding Amount" readonly ></v-text-field>  
                                    </v-flex>
                                    
                                    <v-flex xs12 sm4 v-if="fdl_details.fdl_due_date != ''">
                                      <v-text-field :value="fdl_details.fdl_due_date" label="Interest Due Date" readonly ></v-text-field>  
                                    </v-flex>
                                     <v-flex xs12 sm4 >
                                      <v-text-field :value="fdl_details.loan_due_date" label="Loan Due Date" readonly ></v-text-field>  
                                    </v-flex>
                                </template>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card>
            </v-container>
        </template>
    </div>
</template>

<script>

  import axios from 'axios'

  import NoData from '@/components/NoData'
  
  import pSpinner from '@/components/pSpinner';
  
  import global from '@/components/rbconstants';
  
  import PageHeader from '@/components/PageHeader'

  export default {

    components : {

        NoData : NoData,
        
        PageHeader : PageHeader,
        
        pSpinner : pSpinner,
    },  
    
   
    mounted() {
      
        this.getDataFromApi()
        
        .then(data => {
            
            this.fdl_details = data.fdl_details.fdl_details;
            
            this.fdl = data.fdl_details.fdl;
            
            this.dues = data.fdl_details.dues;
         
            if(this.dues.type == true) {
            
                this.alert = true
                
                this.alert_message = this.dues.message
            
            } else {
            
                this.alert = false 
                
            }
            
            this.loading = false;
          
        })
    },
      
    data: () => ({
        
        page_title : "FD Loan",
        
        fdl : [],
        
        dues: [],
        
        fdl_details : [],
        
        active_tab1: 0,
        
        alert_message: '',
        
        alert : false,
        
        loading : false,
        
        tabs: [
            
            { id: 1, name: "Account Details", route: "loans/fd/:id" },
            { id: 2, name: "Ledger", route: "loans/fd/:id/ledger" },
            
        ],
        
    }),
    
	methods : {
	    
        getDataFromApi() {
            
            this.loading = true;
           
            this.table_loading = true
            
                return new Promise((resolve, reject) => {
                 
                  var app = this;
                  
                  var form_post_data = {};
                  
                  var link = global.links.fd_loan;
                  
                  var deposit_id = this.$route.params.id
                  
                  link = link.replace(':id',deposit_id);
                    
                    axios.post(link, {
                        
                        params : form_post_data,
                    
                    }, { headers : global.header }) .then(function (response) {
                      
                        if(response.status == 200) {
                            
                            // app.loading = false;
                            
                            var fdl_details = response.data.data;
                            
                            setTimeout(() => {
                                
                            app.table_loading = false
                            
                            resolve({
                                
                              fdl_details
                              
                            })
                            
                          }, 1000)
                            
                        }
                        
                    }) .catch(function (error) {
                        
                        if(error.response.data.error.code == 400) {
                        
                            app.$router.push({ name: 'LoanList',  params: { alert: true}})
                        
                        }

                        app.loading = false;
                        
                    });
                    
            });
            
        },
        
        redirectTo(id, link) {
          
          if(id == 1) {
              
              var id = this.$route.params.id;
              
              this.$router.push({ name: 'FDLoan', params: { id: id}});
              
          } else if(id == 2) {
              
            var id = this.$route.params.id;
            
              this.$router.push({ name: 'FDLoanLedger', params: { id: id}});
            
          } 
          
        }
        
	},
	
	
  }
  
</script>
<style scoped>

    .cyb-alert-info {
        color: #5e583f  !important; 
        border: 1px solid #ebccd1 !important;
        border-radius: 4px !important;
        background-color: #fef1a8 !important;
        border-color: #ffdb73 !important;
        margin-left: 20px !important;
        margin-right: 20px !important;
        padding-left: 16px !important;
        padding-top: 8px !important;
        padding-bottom: 2px !important;
        margin-bottom: -7px !important;
    }
    
        
    .close_hover{ color: 	#808080 !important;}
    
    .close_hover:hover {color: rgba(0,0,0,0.87) !important;}

</style>